/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon16Regular = forwardRef('ShareNetworkIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.25 4a2.75 2.75 0 1 1 .825 1.964L6.67 7.338a2.756 2.756 0 0 1 0 1.324l2.405 1.374a2.75 2.75 0 1 1-.745 1.302L5.925 9.964a2.75 2.75 0 1 1 0-3.928L8.33 4.662A2.757 2.757 0 0 1 8.25 4ZM11 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-7 4a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM9.75 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z" })));
});
